'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cascader = require('antd/lib/cascader');

var _cascader2 = _interopRequireDefault(_cascader);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('antd/lib/cascader/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('./index.less');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CascaderWidget = function (_Component) {
  _inherits(CascaderWidget, _Component);

  function CascaderWidget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CascaderWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CascaderWidget.__proto__ || Object.getPrototypeOf(CascaderWidget)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnChange = function (value) {
      var string = '';
      value.forEach(function (entry, index) {
        if (index === 0) {
          string = entry;
        } else {
          string = string + ' / ' + entry;
        }
      });
      _this.props.onChange(string.toString());
    }, _this.handleSetValue = function () {
      if (!_this.props.value) {
        return _this.props.value;
      }

      if (typeof _this.props.value === 'number') {
        return [_this.props.value];
      }

      if (_this.props.value.indexOf(' / ') < 0) {
        return [Number.parseInt(_this.props.value, 10)];
      }

      var array = _this.props.value.split(' / ');
      return array.map(function (entry) {
        return Number.parseInt(entry, 10);
      });
      // this.props.value ? this.props.value.split(' / ') : this.props.value;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CascaderWidget, [{
    key: 'highlightKeyword',
    value: function highlightKeyword(str, keyword, prefixCls) {
      var regex = new RegExp(keyword, 'gi');
      var indices = [];
      var startIndex = 0;

      while (str.toLowerCase().indexOf(keyword.toLowerCase(), startIndex) > -1) {
        indices.push(str.toLowerCase().indexOf(keyword.toLowerCase(), startIndex));
        startIndex = str.toLowerCase().indexOf(keyword.toLowerCase(), startIndex) + keyword.length;
      }

      return str.split(regex).map(function (node, index) {
        return index === 0 ? node : [_react2.default.createElement(
          'span',
          { className: prefixCls + '-menu-item-keyword', key: 'seperator' },
          str.substr(indices[index - 1], keyword.length)
        ), node];
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_cascader2.default, {
        disabled: this.props.disabled,
        options: this.props.schema.options,
        required: this.props.required,
        popupClassName: _index2.default.cascaderPopUp,
        showSearch: {
          render: function render(inputVal, path, prefixCls) {
            return path.map(function (_ref2, index) {
              var label = _ref2.label;

              var node = label.toLowerCase().indexOf(inputVal.toLowerCase()) > -1 ? _this2.highlightKeyword(label, inputVal, prefixCls) : label;
              return index === 0 ? node : [' / ', node];
            });
          },
          filter: function filter(inputVal, path) {
            return path.some(function (option) {
              return option.label.toLowerCase().indexOf(inputVal.toLowerCase()) > -1;
            });
          }
        },
        value: this.handleSetValue(),
        onChange: this.handleOnChange,
        placeholder: this.props.placeholder ? this.props.placeholder : this.props.schema.label + ' \u0441\u043E\u043D\u0433\u043E\u0445'
      });
    }
  }]);

  return CascaderWidget;
}(_react.Component);

CascaderWidget.defaultProps = {
  value: undefined,
  placeholder: '',
  options: {},
  disabled: false,
  required: false
};

CascaderWidget.propTypes = {
  value: _propTypes2.default.any,
  required: _propTypes2.default.bool,
  onChange: _propTypes2.default.func.isRequired,
  schema: _propTypes2.default.object.isRequired,
  placeholder: _propTypes2.default.string,
  options: _propTypes2.default.object,
  disabled: _propTypes2.default.bool
};

exports.default = CascaderWidget;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Form/Widgets/CascaderWidget/index.js
// module id = 895
// module chunks = 0